import { FeatureFlagService } from '../../services/logic-services/feature-flag.service';

export function initializeFeatureFlags(featureFlagService: FeatureFlagService): () => Promise<void> {
    return () => {
        return featureFlagService.loadFeatureFlags();
    };
}
